





































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { cloneDeep } from 'lodash';
import * as service from '@/services/sieves';
import { ISieve, IType, IOperator } from '@/interfaces/sieves';
import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import InputMoney from '@/components/UI/input-money.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { filterByText } from '@/helpers/filterByText';
import { PARAMETER_TYPE_NUMBER } from '@/settings/consts/parameters-keys';
import { toNumber } from '@/helpers/toNumber';

@Component({
  components: { InputMoney, ListMessages, PermissionAuth },
})
export default class Sieves extends BaseComponent {
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public filter: any = {
    term: '',
  };

  public form: any = {
    valid: false,
    rules: {
      description: [(v) => !!v || 'Coloque uma descrição'],
      type: [(v) => (!!v && !!v.tipo) || 'Selecione um tipo'],
      value: [(v) => !!v || 'Coloque um valor'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public headers: any = [
    { text: 'Descrição', value: 'descricao' },
    { text: 'Tipo', value: 'tipo' },
    { text: 'Valor', value: 'valor' },
    { text: 'Ações', value: 'actions', sortable: false, align: 'right' },
  ];

  public data: ISieve[] = [];
  public item: ISieve = {
    id: 0,
    descricao: '',
    tipo: {
      tipo: '',
      descricao: '',
      operadores: [],
    },
    valor: '',
  };

  public types: IType[] = [];

  public onChangeType(val): void {
    if (val.tipo === PARAMETER_TYPE_NUMBER) {
      this.item.valor = toNumber(this.item.valor).toString();
    }
  }

  public beforeMount(): void {
    this.load();
    this.getTypes();
  }

  public customFilter(items, search, filter): any[] {
    const searchLower = search.toString().toLowerCase();
    return items.filter((row) => {
      return (
        filterByText(row, ['descricao', 'valor'], searchLower) &&
        (!this.filter.type || row.tipo.tipo === this.filter.type)
      );
    });
  }

  public onEditItem(item: ISieve): void {
    this.formOpen = true;
    const newItem = cloneDeep(item);
    if (newItem.tipo.tipo === PARAMETER_TYPE_NUMBER) {
      newItem.valor = toNumber(newItem.valor);
    }
    this.item = newItem;
  }

  public onDeleteItem(item: ISieve): void {
    const deleteItem = () => {
      this.loader.start('Deletando registro...');
      service.deleteSieve(item.id).subscribe(
        (data) => {
          this.loader.stop();
          this.load();
        },
        (err) => {
          this.loader.stop();
          this.toast.show('Ocorreu um erro ao deletar o parâmetro', 'error');
        },
      );
    };

    this.dialog.show(
      'error',
      'Excluir Parâmetro',
      'Tem certeza que deseja excluir este parâmetro?',
      'Cancelar',
      '',
      'Excluir',
      deleteItem,
    );
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando registro...');

    if (!this.item.id) {
      service
        .saveSieve({
          id: '',
          descricao: this.item.descricao,
          tipo: this.item.tipo.tipo,
          valor: this.item.valor,
        })
        .subscribe(
          (data) => {
            this.loader.stop();
            this.formOpen = false;
            this.load();
          },
          () => {
            this.loader.stop();
            this.toast.show('Ocorreu um erro ao criar o parâmetro', 'error');
          },
        );
    } else {
      service
        .updateSieve({
          id: this.item.id,
          descricao: this.item.descricao,
          tipo: this.item.tipo.tipo,
          valor: this.item.valor,
        })
        .subscribe(
          (data) => {
            this.loader.stop();
            this.formOpen = false;
            this.load();
          },
          () => {
            this.loader.stop();
            this.toast.show(
              'Ocorreu um erro ao atualizar o parâmetro',
              'error',
            );
          },
        );
    }
  }

  public newItem(): void {
    this.item = {
      id: 0,
      descricao: '',
      tipo: {
        tipo: '',
        descricao: '',
        operadores: [],
      },
      valor: '',
    };
    this.$refs.form.resetValidation();
    this.formOpen = true;
  }

  public closeForm(): void {
    const closeAction = () => {
      this.formOpen = false;
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }

  private load(): void {
    this.data = [];
    this.error = false;
    this.loading = true;
    service.getSieves().subscribe(
      (data) => {
        this.data = data;
        this.loading = false;
      },
      () => {
        this.error = true;
        this.loading = false;
      },
    );
  }

  private getTypes(): void {
    this.types = [];
    service.getSievesTypes().subscribe(
      (data) => {
        this.types = data;
      },
      () => {
        this.error = true;
      },
    );
  }
}
